import {Injectable, OnInit} from '@angular/core';
import {StoreListService} from '~/app/core/common/services/store-list.service';
import {OrderReviewItem} from '~/app/core/common/models/OrderReviewItem';
import {ReportColumnTitles} from '~/app/core/common/models/ReportColumnTitles';
import {orderStatusTxt} from '~/app/core/common/enums/OrderStatusTxt';
import {map} from 'rxjs/operators';
import {ApiService} from '~/app/core/common/services/api.service';
import {OrderReviewItemSerializer} from '~/app/core/common/serializers/OrderReviewItemSerializer';
import {OrderItemSerializer} from '../serializers/OrderItemSerializer';
import {ResourceService} from '~/app/core/common/services/ResourceService';
import {OrderConfirmationItemReport} from '~/app/core/common/models/OrderConfirmationItemReport';
import {BaseService} from '~/app/core/common/services/base.service';
import {ConfirmationService} from '~/app/core/common/services/confirmation.service';
import {NewItem} from '~/app/core/common/models/newItem';


@Injectable({
    providedIn: 'root'
})

export class ReportService extends ResourceService<OrderReviewItem> implements OnInit {
    get totalQuantity(): number {
        return this._totalQuantity;
    }

    set totalQuantity(value: number) {
        this._totalQuantity = value;
    }
    private _customerId: string;
    private _identity: string;
    private _city: string;
    private _state: string;
    private _zip: string;
    private _date: string;
    private _reportType: string;
    private _totalItemPrice = 0;
    private _totalPrice: number;
    private _totalSugQty = 0;
    private _totalOrderQty = 0;
    private _totalQuantity = 0;
    private _totalConfirmQty = 0;
    private _totalRecQty = 0;
    private _orderItems: OrderReviewItem[] = [];
    private _confirmedItems: OrderReviewItem[] = [];
    private _columns: Array<any>;
    private _confirmedColumns: Array<any>;
    private _reportTimeStamp: string;

    constructor(private _storeListService: StoreListService,
                private _confirmationService: ConfirmationService,
                public baseService: BaseService,
                public apiService: ApiService,
                ) {
        super(baseService,
            '',
            '',
            new OrderItemSerializer()
        );
    }
    get reportTimeStamp(): string {
        return this._reportTimeStamp;
    }

    set reportTimeStamp(value: string) {
        this._reportTimeStamp = value;
    }

    get customerId(): string {
        return this._customerId;
    }

    set customerId(value: string) {
        this._customerId = value;
    }

    get identity(): string {
        return this._identity;
    }

    set identity(value: string) {
        this._identity = value;
    }

    get city(): string {
        return this._city;
    }

    set city(value: string) {
        this._city = value;
    }

    get state(): string {
        return this._state;
    }

    set state(value: string) {
        this._state = value;
    }

    get zip(): string {
        return this._zip;
    }

    set zip(value: string) {
        this._zip = value;
    }

    get date(): string {
        return this._date;
    }

    set date(value: string) {
        this._date = value;
    }

    get reportType(): string {
        return this._reportType;
    }

    set reportType(value: string) {
        this._reportType = value;
    }

    get totalItemPrice(): number {
        return this._totalItemPrice;
    }

    set totalItemPrice(value: number) {
        this._totalItemPrice = value;
    }

    get totalPrice(): number {
        return this._totalPrice;
    }

    set totalPrice(value: number) {
        this._totalPrice = value;
    }

    get totalSugQty(): number {
        return this._totalSugQty;
    }

    set totalSugQty(value: number) {
        this._totalSugQty = value;
    }

    get totalOrderQty(): number {
        return this._totalOrderQty;
    }

    set totalOrderQty(value: number) {
        this._totalOrderQty = value;
    }

    get totalConfirmQty(): number {
        return this._totalConfirmQty;
    }

    set totalConfirmQty(value: number) {
        this._totalConfirmQty = value;
    }

    get totalRecQty(): number {
        return this._totalRecQty;
    }

    set totalRecQty(value: number) {
        this._totalRecQty = value;
    }

    get orderItems(): OrderReviewItem[] {
        return this._orderItems;
    }

    set orderItems(value: OrderReviewItem[]) {
        this._orderItems = value;
    }

    get confirmedItems(): OrderReviewItem[] {
        return this._confirmedItems;
    }

    set confirmedItems(value: OrderReviewItem[]) {
        this._confirmedItems = value;
    }

    get columns(): Array<any> {
        return this._columns;
    }

    set columns(value: Array<any>) {
        this._columns = value;
    }

    get confirmedColumns(): Array<any> {
        return this._confirmedColumns;
    }

    set confirmedColumns(value: Array<any>) {
        this._confirmedColumns = value;
    }

    ngOnInit() {
        this._customerId = this._storeListService.pickedCustomerId.toString();
        this._identity = this._storeListService.pickedStore.identity;
        this._city = this._storeListService.pickedStore.city;
        this._state = this._storeListService.pickedStore.state;
        this._zip = this._storeListService.pickedStore.zip;
    }

    reportTotals() {
        const numbers = this.orderItems.map(i => i.totalCost);
        this.orderItems.forEach(item => {
            console.log(item);
        });
        this.totalItemPrice = numbers.reduce((a, b) => a + b, 0);
        this.totalPrice = this.orderItems.reduce((total, dataItem) => total + dataItem.totalCost, 0);
        this.totalQuantity = this.orderItems.reduce((total, dataItem) => total + dataItem.quantity, 0);
        this.totalOrderQty = this.orderItems.reduce((total, dataItem) => total + dataItem.orderedQuantity, 0);
        this.totalSugQty = this.orderItems.reduce((total, dataItem) => total + dataItem.qtySuggested, 0);
        this.totalConfirmQty = this.orderItems.reduce((total, dataItem) => total + dataItem.confirmedQuantity, 0);
        this.totalRecQty = this.orderItems.reduce((total, dataItem) => total + dataItem.receivedQuantity, 0);
    }

    async onLoadReport(trackingId: string, storeNumber: string): Promise<any> {
        switch (this.reportType) {
            case orderStatusTxt.PLACED:
                await this.getOrderReviewReport(trackingId).toPromise()
                    .then((value) => {
                        value.forEach(item => {
                            if (item.qtySuggested === undefined) {
                                item.qtySuggested = 0;
                            }
                            item.reportType = orderStatusTxt.PLACED;
                            this.orderItems.push(item);
                        });
                        this.reportType = orderStatusTxt.PLACED;
                        this.reportTotals();
                    });
                this.columns = ReportColumnTitles.ORDER_REVIEW_MOBILE_PLACED_REPORT_COLUMNS;
                break;
            case orderStatusTxt.SHIPPED:
                await this.getOrderConfirmItemReport(trackingId).toPromise().then((value) => {
                    value.forEach(item => {
                        if (item.qtySuggested === undefined) {
                            item.qtySuggested = 0;
                        }
                        if (item.qtyConfirmed === undefined) {
                            item.qtyConfirmed = 0;
                        }
                        item.reportType = orderStatusTxt.SHIPPED;
                        this.confirmedItems.push(item);
                    });
                });
                this.confirmedColumns = ReportColumnTitles.ORDER_REVIEW_MOBILE_CONFIRM_REPORT_COLUMNS;
                this.getOrderShipAndConfirmReport(trackingId, storeNumber).toPromise().then((value) => {
                    value.forEach(item => {
                        if (item.qtySuggested === undefined) {
                            item.qtySuggested = 0;
                        }
                        if (item.orderedQuantity === undefined) {
                            item.orderedQuantity = 0;
                        }
                        if (item.receivedQuantity === undefined) {
                            item.receivedQuantity = 0;
                        }
                        if (item.confirmedQuantity === undefined) {
                            item.confirmedQuantity = 0;
                        }
                        item.reportType = orderStatusTxt.SHIPPED;
                        this.orderItems.push(item);
                    });
                    this.reportType = orderStatusTxt.SHIPPED;
                    this.reportTotals();
                });
                this.columns = ReportColumnTitles.ORDER_REVIEW_MOBILE_SHIPPED_REPORT_COLUMNS;
                break;
            case orderStatusTxt.CONFIRMED:
                await this.getOrderConfirmItemReport(trackingId).toPromise().then((value) => {
                    value.forEach(item => {
                        if (item.qtySuggested === undefined) {
                            item.qtySuggested = 0;
                        }
                        if (item.qtyConfirmed === undefined) {
                            item.qtyConfirmed = 0;
                        }
                        item.reportType = orderStatusTxt.CONFIRMED;
                        this.confirmedItems.push(item);
                    });
                });
                this.confirmedColumns = ReportColumnTitles.ORDER_REVIEW_MOBILE_CONFIRM_REPORT_COLUMNS;
                this.getOrderShipAndConfirmReport(trackingId, storeNumber).toPromise().then((value) => {
                    value.forEach(item => {
                        if (item.qtySuggested === undefined) {
                            item.qtySuggested = 0;
                        }
                        if (item.orderedQuantity === undefined) {
                            item.orderedQuantity = 0;
                        }
                        if (item.receivedQuantity === undefined) {
                            item.receivedQuantity = 0;
                        }
                        if (item.confirmedQuantity === undefined) {
                            item.confirmedQuantity = 0;
                        }
                        item.reportType = orderStatusTxt.SHIPPED;
                        this.orderItems.push(item);
                    });
                    this.reportType = orderStatusTxt.CONFIRMED;
                    this.reportTotals();
                });
                this.columns = ReportColumnTitles.ORDER_REVIEW_MOBILE_SHIPPED_REPORT_COLUMNS;
                break;
            case orderStatusTxt.CONFIRMED_ACK:
                await this.getOrderConfirmItemReport(trackingId).toPromise().then((value) => {
                    value.forEach(item => {
                        if (item.qtySuggested === undefined) {
                            item.qtySuggested = 0;
                        }
                        if (item.qtyConfirmed === undefined) {
                            item.qtyConfirmed = 0;
                        }
                        item.reportType = orderStatusTxt.CONFIRMED_ACK;
                        this.confirmedItems.push(item);
                    });
                });
                this.confirmedColumns = ReportColumnTitles.ORDER_REVIEW_MOBILE_CONFIRM_REPORT_COLUMNS;
                await this.getOrderShipAndConfirmReport(trackingId, storeNumber).toPromise().then((value) => {
                    value.forEach(item => {
                        if (item.qtySuggested === undefined) {
                            item.qtySuggested = 0;
                        }
                        if (item.orderedQuantity === undefined) {
                            item.orderedQuantity = 0;
                        }
                        if (item.receivedQuantity === undefined) {
                            item.receivedQuantity = 0;
                        }
                        if (item.confirmedQuantity === undefined) {
                            item.confirmedQuantity = 0;
                        }
                        item.reportType = orderStatusTxt.SHIPPED;
                        this.orderItems.push(item);
                    });
                    this.reportType = orderStatusTxt.CONFIRMED_ACK;
                    this.reportTotals();
                });
                this.columns = ReportColumnTitles.ORDER_REVIEW_MOBILE_SHIPPED_REPORT_COLUMNS;
                break;
            case orderStatusTxt.DELIVERED:
                this.getOrderShipAndConfirmReport(trackingId, storeNumber).toPromise().then((value) => {
                    value.forEach(item => {
                        if (item.qtySuggested === undefined) {
                            item.qtySuggested = 0;
                        }
                        if (item.orderedQuantity === undefined) {
                            item.orderedQuantity = 0;
                        }
                        if (item.receivedQuantity === undefined) {
                            item.receivedQuantity = 0;
                        }
                        if (item.confirmedQuantity === undefined) {
                            item.confirmedQuantity = 0;
                        }
                        item.reportType = orderStatusTxt.SHIPPED;
                        this.orderItems.push(item);
                    });
                    this.reportType = orderStatusTxt.DELIVERED;
                    this.reportTotals();
                });
                this.columns = ReportColumnTitles.ORDER_REVIEW_MOBILE_SHIPPED_REPORT_COLUMNS;
                break;
            default :
                break;
        }
        return;
    }

    public getOrderReviewReport(trackingId: string) {
        return this.baseService.getHttpObject<OrderReviewItem>(
            'getOrderReviewReport',
            'report-service',
            this.apiService.orderReviewDetailsURL + `?trackingId=${trackingId}`)
            .pipe(map((data: any) => this.convertData(data, new OrderReviewItemSerializer())));
    }

    public getOrderShipAndConfirmReport(trackingId: string, storeNumber: string) {
        return this.baseService.getHttpObject<object>(
            'getOrderShipAndConfirmReport',
            'report-service',
            this.apiService.orderReviewConfirmURL + `?customerId=${storeNumber}&trackingId=${trackingId}`)
            .pipe(map((data: any) => (data)));
    }

    public getOrderConfirmItemReport(trackingId: string) {
        return this.baseService.getHttpObject<OrderConfirmationItemReport>(
            'getOrderConfirmItemReport',
            'report-service',
            this.apiService.confirmedItemsReportURL + `?trackingId=${trackingId}`)
            .pipe(map((data: any) => (data)));
    }

    public getNewItemsReport(customerId: number, fromDate:  string) {
        return this.baseService.getHttpObject<NewItem[]>(
            'getNewItemsReport',
            'report-service',
            this.apiService.newItemReportURL + `/${customerId}/${fromDate}`)
            .pipe(map((data: NewItem[]) => (data)));
    }

}
